import { Loader2, PhoneOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

/**
 * "End the meeting for everyone?" (board m5gc #7) — a real dialog instead of
 * `window.confirm`: it says what ending does (everyone is disconnected, the
 * notes are finished), the destructive action is red, and Escape / Cancel
 * back out. `busy` keeps it open while `meetings.end` runs.
 */
export function EndMeetingDialog({
  open,
  busy,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  busy: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) {
  const { t } = useTranslation('meet')
  return (
    <AlertDialog open={open} onOpenChange={(next) => !busy && onOpenChange(next)}>
      <AlertDialogContent data-testid="end-meeting-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('endDialog.title')}</AlertDialogTitle>
          <AlertDialogDescription>{t('endDialog.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>{t('endDialog.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={busy}
            onClick={(event) => {
              // Radix closes on Action by default; the caller decides when
              // the dialog goes away (after the request has succeeded).
              event.preventDefault()
              onConfirm()
            }}
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <PhoneOff className="h-4 w-4" />}
            {t('endDialog.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
